import { axiosGet, axiosPost } from "./apiClient";

const BRANCH_ZONE_BASE = `${process.env.REACT_APP_BASE_URL}/branch/zones`;
const ORDER_BASE = `${process.env.REACT_APP_BASE_URL}/orders`;

const cleanParams = (obj = {}) => {
  const out = {};
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (value !== null && value !== undefined && value !== "") {
      out[key] = value;
    }
  });
  return out;
};

const getZonesOverview = async ({ activeOnly = true, zoneType = null, branchId = null } = {}) => {
  return axiosGet(
    `${BRANCH_ZONE_BASE}/overview`,
    cleanParams({
      activeOnly: activeOnly ? 1 : 0,
      zoneType,
      branchId,
    })
  );
};

const locatePointInZones = async ({ latitude, longitude, activeOnly = true, zoneType = null, branchId = null }) => {
  return axiosPost(`${BRANCH_ZONE_BASE}/locate-point`, cleanParams({
    latitude,
    longitude,
    activeOnly: activeOnly ? 1 : 0,
    zoneType,
    branchId,
  }));
};

const getOrderLocationMap = async (orderId) => {
  return axiosGet(`${ORDER_BASE}/location/${orderId}`);
};

const orderLocationApi = {
  getZonesOverview,
  locatePointInZones,
  getOrderLocationMap,
};

export default orderLocationApi;